var _g, _path, _path2, _path3, _path4, _path5, _g2, _g3, _g4, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g5, _g6, _path24, _g7, _path25;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-md",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00319c",
    d: "M0 0h170.667v512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffde00",
    d: "M170.667 0h170.666v512H170.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M341.333 0H512v512H341.333z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.62 690.94v63.779c0 3.544 0 7.087-3.543 7.087-3.544 0-7.087 7.087-7.087 10.63 0 7.087 3.543 10.63 7.087 10.63h31.889c3.544 0 7.087-3.543 7.087-10.63-.228-3.723-3.543-10.63-7.087-10.63-3.543 0-3.543-3.543-3.543-7.087V690.94",
    fillRule: "evenodd",
    transform: "matrix(.46695 -.29552 .30926 .4462 -5.143 64.498)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ff1900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.17 696.26c0 24.461-9.518 44.291-21.26 44.291-11.741 0-21.26-19.83-21.26-44.291s9.518-44.291 21.26-44.291c11.741 0 21.26 19.83 21.26 44.291z",
    fillRule: "evenodd",
    transform: "matrix(.42858 -.34452 .36055 .40954 -29.658 77.262)",
    stroke: "#000",
    strokeWidth: 3.125,
    fill: "#a77b3b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.62 690.94v63.779c0 3.544 0 7.087-3.543 7.087-3.544 0-7.087 7.087-7.087 10.63 0 7.087 3.543 10.63 7.087 10.63h31.889c3.544 0 7.087-3.543 7.087-10.63-.228-3.723-3.543-10.63-7.087-10.63-3.543 0-3.543-3.543-3.543-7.087V690.94",
    fillRule: "evenodd",
    transform: "matrix(.48902 .26089 -.27302 .46728 313.353 -58.253)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ff1900"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M421.65 701.58h-28.347c-.937.938-8.998 54.066-17.716 74.409-10.63 24.803-42.465 46.69-42.465 46.69s19.073 6.045 24.748 10.003c1.411-.415 31.835-7.086 35.378-46.063 3.544 38.977-21.205 56.693-21.205 56.693s35.433 10.63 35.433 35.433c0-24.803 35.434-35.433 35.434-35.433s-17.772-17.716-21.315-56.693c7.086 38.977 34.077 45.648 35.488 46.063 5.675-3.958 24.748-10.003 24.748-10.003s-31.835-21.887-42.465-46.69c-8.718-20.343-16.779-73.471-17.716-74.409z",
    fillRule: "evenodd",
    transform: "matrix(.56007 0 0 .53518 29.717 -86.339)",
    stroke: "#000",
    strokeWidth: 3.125,
    fill: "#a77b3b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M336.61 467.7l53.15 17.716c17.716 0 35.433-17.697 35.433-35.414.589-39.414-14.174-53.168-17.717-53.168l7.087-7.087-10.63-10.63s3.554-18.382 38.976-17.698c35.421.685 35.433 17.717 35.433 35.433 0 17.717-17.716 17.717-17.716 53.15 0 17.717 17.716 35.433 35.433 35.433l53.15-17.716v177.16h-212.6v-177.18z",
    fillRule: "evenodd",
    transform: "matrix(.56007 0 0 .53518 9.84 -55.998)",
    stroke: "#000",
    strokeWidth: 3.125,
    fill: "#a77b3b"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.16 292.24l14.645 14.964 14.644-14.964 14.645 14.964 29.29-14.964 14.261 15.809 15.028-15.809 21.605 15.809 22.329-15.809 14.645 14.964 14.645-14.964",
    transform: "matrix(.1355 0 0 .38018 203.065 87.002)",
    strokeWidth: 0.603
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.28 435.83l-7.086 38.976m10.636-38.976v38.976m7.08-38.976v38.976M450 435.83l3.543 38.976m3.547-38.976l3.543 38.976",
    transform: "matrix(.56007 0 0 .53518 9.84 -55.998)",
    strokeWidth: 0.25
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 3.125
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.9 361.42c35.433 17.717 35.433 53.149 35.433 70.866-1.251 16.117 0 354.33 0 354.33s-2.306-20.022-17.717-35.433L318.9 733.467l-17.717-17.717c-12.951-11.774-17.716-35.433-17.716-53.15V414.57s0-17.717 35.433-53.15z",
    fillRule: "evenodd",
    transform: "matrix(-.56007 0 0 .53518 357.129 -55.998)",
    fill: "#a77b3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.46 574.02c.417 0 17.716-17.717 17.716-17.717l17.717 17.717 17.716-17.717 17.717 17.717",
    transform: "matrix(-.56007 0 0 .53518 357.129 -131.85)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.46 574.02c.417 0 17.716-17.717 17.716-17.717l17.717 17.717 17.716-17.717 17.717 17.717",
    transform: "matrix(-.56007 0 0 -.53518 357.129 492.026)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.46 574.02c.417 0 17.716-17.717 17.716-17.717l17.717 17.717 17.716-17.717 17.717 17.717",
    transform: "matrix(-.56007 0 0 .53518 357.129 -93.924)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.39 556.99l-.208 158.76",
    transform: "matrix(-.56007 0 0 1.01529 357.129 -399.621)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.39 539.27l-.208 176.48",
    transform: "matrix(-.56007 0 0 .91125 347.322 -316.063)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.39 539.27l-.208 176.48",
    transform: "matrix(-.56007 0 0 1.0208 337.398 -384.615)",
    fill: "none"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 3.125
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.9 361.42c35.433 17.717 35.433 53.149 35.433 70.866-1.251 16.117 0 354.33 0 354.33s-2.306-20.022-17.717-35.433L318.9 733.467l-17.717-17.717c-12.951-11.774-17.716-35.433-17.716-53.15V414.57s0-17.717 35.433-53.15z",
    fillRule: "evenodd",
    transform: "matrix(.56007 0 0 .53518 158.68 -55.998)",
    fill: "#a77b3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.46 574.02c.417 0 17.716-17.717 17.716-17.717l17.717 17.717 17.716-17.717 17.717 17.717",
    transform: "matrix(.56007 0 0 .53518 158.68 -131.85)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.46 574.02c.417 0 17.716-17.717 17.716-17.717l17.717 17.717 17.716-17.717 17.717 17.717",
    transform: "matrix(.56007 0 0 -.53518 158.68 492.026)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.46 574.02c.417 0 17.716-17.717 17.716-17.717l17.717 17.717 17.716-17.717 17.717 17.717",
    transform: "matrix(.56007 0 0 .53518 158.68 -93.924)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.39 556.99l-.208 158.76",
    transform: "matrix(.56007 0 0 1.01529 158.68 -399.621)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.39 539.27l-.208 176.48",
    transform: "matrix(.56007 0 0 .91125 168.486 -316.063)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.39 539.27l-.208 176.48",
    transform: "matrix(.56007 0 0 1.0208 178.405 -384.615)",
    fill: "none"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M177.17 696.26c0 24.461-9.518 44.291-21.26 44.291-11.741 0-21.26-19.83-21.26-44.291s9.518-44.291 21.26-44.291c11.741 0 21.26 19.83 21.26 44.291z",
    fillRule: "evenodd",
    transform: "matrix(.51699 .20584 -.21541 .49401 290.24 -73.211)",
    stroke: "#000",
    strokeWidth: 3.125,
    fill: "#a77b3b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "red",
    d: "M198.366 203.794h119.07v56.89h-119.07z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M198.366 260.684h119.071v28.445c0 18.963-29.767 18.963-59.535 37.926-29.768-18.963-59.536-18.963-59.536-37.926v-28.445z",
    fillRule: "evenodd",
    fill: "#564dff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M336.61 485.43h212.6v159.45c0 35.433-53.15 35.433-106.3 70.866-53.149-35.433-106.3-35.433-106.3-70.866V485.43z",
    transform: "matrix(.56007 0 0 .53518 9.842 -55.998)",
    stroke: "#ff0",
    strokeWidth: 2.5,
    fill: "none"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M385.59 129.9s-50.618 55.447-50.618 108.6c0 53.149 53.149 70.866 53.149 70.866s-17.717 0-17.717 70.866c0 35.433 53.15 17.717 53.15 35.433 0 17.717-.751 60.578 0 88.583 0 17.716-35.433 0-35.433 17.716 0 8.859 26.575 53.15 53.15 53.15 26.574 0 53.149-44.291 53.149-53.15 0-17.716-35.433 0-35.433-17.716v-88.583c0-17.716 53.15 0 53.15-35.433 0-70.866-17.717-70.866-17.717-70.866s53.15-17.717 53.15-70.866-50.619-108.6-50.619-108.6c0-.001 28.473 73.163 28.473 108.6 0 17.717-13.287 53.149-48.72 53.149 0 0-8.961-17.716-17.717 0 0 0-10.189-17.716-17.716 0-2.598 6.115-7.207-17.716-17.717 0-4.465 4.697-7.984-17.716-17.717 0-17.716 0-53.148-17.716-53.149-53.149 0-35.433 32.902-108.6 32.902-108.6z",
    fillRule: "evenodd",
    transform: "matrix(.39205 0 0 .2513 84.901 174.943)",
    stroke: "#000",
    strokeWidth: 3.011,
    fill: "#ff0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M382.68 248.03c-3.543 3.543 4.581 61.274 7.087 63.779 3.543 3.543 24.803 3.543 28.346 0 2.525-2.525 0-56.693-3.543-60.236-3.543-3.544-29.384-6.049-31.89-3.543z",
    fillRule: "evenodd",
    transform: "matrix(.39205 0 0 .2513 86.397 224.929)",
    stroke: "#000",
    strokeWidth: 3.011,
    fill: "#ff0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M382.68 248.03c-3.543 3.543 4.581 61.274 7.087 63.779 3.543 3.543 24.803 3.543 28.346 0 2.525-2.525 0-56.693-3.543-60.236-3.543-3.544-29.384-6.049-31.89-3.543z",
    fillRule: "evenodd",
    transform: "matrix(-.39205 0 0 .2513 429.412 224.929)",
    stroke: "#000",
    strokeWidth: 3.011,
    fill: "#ff0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M414.57 228.54c0 8.806-7.139 15.945-15.945 15.945-8.806 0-15.945-7.139-15.945-15.945 0-8.806 7.139-15.945 15.945-15.945 8.806 0 15.945 7.139 15.945 15.945z",
    fillRule: "evenodd",
    transform: "matrix(.45063 0 0 .31327 63.903 210.41)",
    stroke: "#000",
    strokeWidth: 3.011,
    fill: "#ff0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M414.57 228.54c0 8.806-7.139 15.945-15.945 15.945-8.806 0-15.945-7.139-15.945-15.945 0-8.806 7.139-15.945 15.945-15.945 8.806 0 15.945 7.139 15.945 15.945z",
    fillRule: "evenodd",
    transform: "matrix(.45063 0 0 .31328 92.642 210.41)",
    stroke: "#000",
    strokeWidth: 3.011,
    fill: "#ff0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M270.409 311.012c0 1.23-1.555 2.226-3.473 2.226s-3.473-.997-3.473-2.226c0-1.23 1.555-2.226 3.473-2.226s3.473.997 3.473 2.226zm-18.062 0c0 1.23-1.555 2.226-3.473 2.226s-3.473-.997-3.473-2.226c0-1.23 1.555-2.226 3.473-2.226s3.473.997 3.473 2.226z",
    fillRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    transform: "matrix(.54641 0 0 .52213 17.827 -47.302)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ff0",
    d: "M439.37 549.92l-7.78-10.26-12.77 1.75 1.76-12.76-10.26-7.78 10.26-7.79-1.76-12.76 12.77 1.76 7.78-10.27 7.78 10.27 12.77-1.76-1.76 12.76 10.26 7.79-10.26 7.78 1.76 12.76-12.77-1.75z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M496.06 591.73l21.26 10.63 21.26-10.63-21.26-10.63-21.26 10.63z",
    fillRule: "evenodd",
    transform: "matrix(.56007 0 0 .53518 9.84 -55.998)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ff0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M496.06 591.73l21.26 10.63 21.26-10.63-21.26-10.63-21.26 10.63z",
    fillRule: "evenodd",
    transform: "matrix(.56007 0 0 .53518 -75.491 -55.998)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ff0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M535.04 659.06c-3.543-7.086-14.173-10.63-21.259-10.63-7.087 0-14.174 0-21.26 10.63 0-14.173 10.502-21.26 21.26-21.26 10.756 0 21.259 10.503 21.259 21.26z",
    fillRule: "evenodd",
    transform: "matrix(.48568 -.26652 .27892 .4641 -137.542 131.374)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ff0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M386.22 651.97a7.087 7.087 0 1 1-14.173 0 7.087 7.087 0 0 1 14.173 0z",
    fillRule: "evenodd",
    transform: "matrix(.56007 0 0 .53518 7.856 -65.48)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ff0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M386.22 651.97a7.087 7.087 0 1 1-14.173 0 7.087 7.087 0 0 1 14.173 0z",
    fillRule: "evenodd",
    transform: "matrix(.56007 0 0 .53518 3.887 -52.206)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ff0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M386.22 651.97a7.087 7.087 0 1 1-14.173 0 7.087 7.087 0 0 1 14.173 0z",
    fillRule: "evenodd",
    transform: "matrix(.56007 0 0 .53518 1.903 -59.79)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ff0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M386.22 651.97a7.087 7.087 0 1 1-14.173 0 7.087 7.087 0 0 1 14.173 0z",
    fillRule: "evenodd",
    transform: "matrix(.56007 0 0 .53518 11.825 -52.206)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ff0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M386.22 651.97a7.087 7.087 0 1 1-14.173 0 7.087 7.087 0 0 1 14.173 0z",
    fillRule: "evenodd",
    transform: "matrix(.56007 0 0 .53518 13.81 -59.79)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ff0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M386.22 651.97a7.087 7.087 0 1 1-14.173 0 7.087 7.087 0 0 1 14.173 0z",
    fillRule: "evenodd",
    transform: "matrix(.56007 0 0 .53518 7.856 -57.894)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ff0"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.726 158.921c-10.016 0-11.34 1.58-15.876 3.161 0-4.361 11.153-9.481 21.169-9.481 0 3.16-2.647 6.321-5.293 6.32z",
    fill: "#da4500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.934 148.803c0 2.095-1.777 3.793-3.969 3.793s-3.969-1.698-3.969-3.793 1.777-3.793 3.97-3.793 3.968 1.698 3.968 3.793z",
    fill: "#cac9c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.42 357.87v10.63h17.717v53.15h10.63V368.5h17.716v-10.63h-17.716v-14.173h-10.63v14.173H361.42z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ff0",
    transform: "matrix(.56007 0 0 .53518 9.84 -55.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 152.602c-11.684 0-18.52 1.053-23.813 3.16 0-5.815 6.837-12.642 18.521-12.642 2.646 0 5.293 6.321 5.293 9.482z",
    fill: "#da4500"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.323 612.99c-14.173-14.17-16.634-21.36 3.543-10.1l283.75 247.5-3.366 6.968-283.93-244.37z",
    transform: "matrix(.31554 .24102 -.11439 .19257 189.696 119.017)",
    stroke: "#000",
    strokeWidth: 0.875,
    fill: "#008500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.337 329.631c.625-8.603-15.127-17.91-15.75-17.306-.623.604.958 5.614 3.945 8.224-5.72-2.947-11.712-4.762-11.837-3.482-.467 1.725 8.89 5.844 9.666 7.435.127 1.137-6.87.989-6.744 2.126.127 1.137 19.711 11.032 20.72 3.003zm-15.739-25.062c.625-8.604-15.127-17.911-15.75-17.306-.623.604.958 5.613 3.945 8.224-5.72-2.947-11.712-4.762-11.838-3.483-.466 1.725 8.89 5.845 9.667 7.436.127 1.137-6.87.988-6.744 2.125.127 1.137 19.711 11.032 20.72 3.003zm-12.044-22.756c.625-8.604-15.127-17.911-15.75-17.306-.623.604.958 5.613 3.945 8.224-5.72-2.947-11.712-4.762-11.837-3.483-.467 1.725 8.89 5.845 9.667 7.436.127 1.137-6.872.988-6.745 2.125.128 1.138 19.711 11.033 20.72 3.003zm-11.907-24.656c.625-8.603-15.127-17.91-15.75-17.306-.623.604.958 5.614 3.945 8.224-5.72-2.947-11.712-4.762-11.837-3.482-.467 1.725 8.89 5.844 9.667 7.435.126 1.137-6.872.988-6.745 2.126.127 1.137 19.711 11.032 20.72 3.003z",
    fill: "#008f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.74 256.04c7.622-4.618 6.129-22.258 5.25-22.38-.88-.12-4.164 4.065-4.593 7.912-.908-6.15-2.93-11.836-4.082-11.174-1.73.663.344 10.306-.537 11.847-.883.771-4.906-4.702-5.79-3.93-.882.771 2.386 21.708 9.752 17.725zm11.04 21.646c8.798-1.922 13.554-19.026 12.768-19.42-.786-.395-5.345 2.503-7.094 5.991 1.294-6.085 1.375-12.09.057-11.835-1.863.073-3.277 9.825-4.645 10.996-1.102.446-2.982-5.997-4.084-5.552-1.102.446-5.336 21.225 2.998 19.82zm13.188 22.143c8.024-3.948 8.191-21.645 7.327-21.84-.864-.197-4.528 3.691-5.317 7.485-.326-6.202-1.807-12.039-3.017-11.478-1.786.512-.624 10.294-1.645 11.753-.952.693-4.446-5.103-5.398-4.41-.952.693.34 21.826 8.05 18.489zm14.274 28.909c8.4-3.151 10.44-20.741 9.602-21.02-.839-.278-4.896 3.236-6.082 6.934.332-6.202-.523-12.152-1.787-11.711-1.83.337-1.71 10.18-2.88 11.534-1.021.597-3.883-5.507-4.903-4.91-1.021.598-1.973 21.747 6.05 19.173z",
    fill: "#008f00"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M209.06 775.98c0 7.828-10.312 14.173-23.031 14.173-12.72 0-23.031-6.346-23.031-14.173 0-7.828 10.312-14.173 23.031-14.173 12.72 0 23.031 6.346 23.031 14.173z",
    fillRule: "evenodd",
    transform: "matrix(.48902 .26089 -.27302 .46728 313.353 -58.253)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ff1900"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    fillRule: "evenodd",
    fill: "#ff0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.91 414.57v-7.087h7.086v-7.086h7.087v7.086h7.086v7.087h-7.086v17.716h-7.087V414.57h-7.086z",
    transform: "matrix(.40549 .1277 -.14842 .38308 363.626 58.049)",
    strokeWidth: 0.625
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.63,
    d: "M162.99 474.8h7.087v205.51h-7.087z",
    transform: "matrix(.40549 .1277 -.14842 .38308 363.626 58.049)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.625,
    d: "M159.45 676.77h14.173v56.693H159.45zm-3.54-237.4h21.259c14.174 0-3.543 38.976-3.543 38.976h-14.173s-17.717-38.976-3.543-38.976z",
    transform: "matrix(.40549 .1277 -.14842 .38308 363.626 58.049)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.62 434.06c0 2.935-3.173 5.315-7.087 5.315s-7.086-2.38-7.086-5.315 3.173-5.315 7.086-5.315 7.087 2.38 7.087 5.315z",
    strokeWidth: 0.625,
    transform: "matrix(.40549 .1277 -.14842 .38308 363.626 58.049)"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M209.06 775.98c0 7.828-10.312 14.173-23.031 14.173-12.72 0-23.031-6.346-23.031-14.173 0-7.828 10.312-14.173 23.031-14.173 12.72 0 23.031 6.346 23.031 14.173z",
    fillRule: "evenodd",
    transform: "matrix(.46695 -.29552 .30926 .4462 -5.143 64.498)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ff1900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMd);
export default __webpack_public_path__ + "static/media/md.3c40de435115935ac46aa8660645b892.svg";
export { ForwardRef as ReactComponent };